export default __webpack_public_path__ + "1910d0153d99c1949d234310b7c0b3fe.svg";